import React from 'react';
import cn from 'classnames';
import s from './style.module.css';

const Flow = ({ children, includeAxis }) => (
	<div className={cn(s.wrap, { [s.includeAxis]: includeAxis })}>{children}</div>
);

export default Flow;
